/**
 *
 * InternalServerErrorPage
 *
 */
import React, { memo } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
// import { messages } from './messages';
import { LeftComponent } from '../NotFoundPage';
import { Button } from 'core/components/Button/Loadable';

interface Props {}

export const InternalServerErrorPage = memo((props: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();

  return (
    <Div>
      {t('')}
      {/*  {t(...messages.someThing())}  */}
      <div className="grid grid-cols-10  w-screen h-screen">
        <LeftComponent />
        <div className="col-span-6 h-full bg-[url('/src/features/Authentication/assets/BackGroundAuth.webp')] bg-cover">
          <div className="w-full h-full px-[15%] py-[22.5%]">
            <h1 className="font-bold text-9xl mb-[4%] ">500</h1>
            <p className="font-regular text-neutral-60  text-4xl">
              Internal Server Error
            </p>
            <p className="text-xl my-[4%] font-extralight text-neutral-60">
              Some unexpected error has occured, go back to home page.
            </p>
            <Button type="primary" label="Go Back" />
          </div>
        </div>
      </div>
    </Div>
  );
});

const Div = styled.div``;
